
import { sentryHub } from "Utils/sentryHelper"

import worker from 'workerize-loader?inline!Utils/AmplitudeWoker.js'





let amplWorker;



export function amplitudeInit(aUserId, gameId = "MissCherry") {
    //console.log(`Amplitude...................... user id: ${aUserId}`)
    //console.log(`Amplitude...................... DEV_AMPLITUDE_APP_KEY: ${process.env.DEV_AMPLITUDE_APP_KEY}`)
    if (!amplWorker) {
        try {
            amplWorker = worker();
        } catch (e) {
            sentryHub.captureMessage("can't create worker for Amplitude");
            return
        }
    }
    


    amplWorker.postMessage({ amplitudeMethod: "init", userId: aUserId, gameId: gameId })
};


export function sendTrack(trackEvent, data = null) {
    if (!amplWorker) return
    let msg = {};
    msg.amplitudeMethod = "track";
    msg.value = data;
    msg.trackEvent = trackEvent;
    amplWorker.postMessage(msg);
}


export const TrackEvent = {
    AppInit: "LS App Init",
    DropWinScreenShown: "Drop Win Screen Shown",
    DropScreenShown: "Drop Screen Shown",
    DropScreenClosed: "Drop Screen Closed",
    DropScreenFullyShown: "Drop Screen Fully Shown",
    ShowMoreButtonTapped: "Show More Button Tapped",
    DropWinScreenClosed: "Drop Win Screen Closed",
    DropPrizesButtonTapped: "Drop Prizes Button Tapped",
    DropRulesButtonTapped: "Drop Rules Button Tapped",
    JoinToCampaing: "Join to Campaign",
    SubscribedOnCampaign: "Subscribed on Campaign",
    CoinMoved: "Coin Moved",
};